import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { UserBannerChildren } from 'hb-builder/components/BuilderComponents/block/UserBanner/types/UserBannerChildren';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

import Buttons from './Buttons';
import Headline from './Headline';
import Image from './Image';
import ProfileCompletion from './ProfileCompletion';

const Content = ({
  item,
  onChange,
}: ComponentSettingsTab & { item: { children: UserBannerChildren } }) => {
  const [
    image,
    headline,
    buttonPost,
    buttonEvent,
    buttonPortFolio,
    buttonAccount,
    profileCompletion,
  ] = item.children;

  const buttons = [buttonPost, buttonEvent, buttonPortFolio, buttonAccount];

  return (
    <Wrapper>
      <AccordionTitle isInitiallyOpen title={__('Image')}>
        <Image item={image} onChange={onChange} />
      </AccordionTitle>
      <AccordionTitle isInitiallyOpen title={__('Headline')}>
        <Headline item={headline} onChange={onChange} />
      </AccordionTitle>
      <AccordionTitle isInitiallyOpen title={__('Profile Completion')}>
        <ProfileCompletion item={profileCompletion} onChange={onChange} />
      </AccordionTitle>
      {buttons.map((button, index) => {
        const btnPosition = index + 1;

        return (
          <AccordionTitle
            isInitiallyOpen={btnPosition === 1}
            title={__('Button %{btnPosition}').i__({
              btnPosition: String(btnPosition),
            })}
            key={button.id}
          >
            <Buttons item={button} onChange={onChange} />
          </AccordionTitle>
        );
      })}
    </Wrapper>
  );
};
export default Content;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
